import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

import { MdEmail } from 'react-icons/md';
import { SiMessenger } from 'react-icons/si';
import { SiTelegram } from 'react-icons/si';

import './contact.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_4iib7s7',
        'template_pu0r51s',
        form.current,
        'CYVYKH2OW_gUTEoMg'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <section id="contact">
      <h2>Contact Me</h2>
      <p className="center-me">
        Interested in working together? If you have any questions don't hesitate
        to ask.
      </p>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>tomio.koshikawajr@gmail.com</h5>
            <a href="mailto:tomio.koshikawajr@gmail.com" target="__blank">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <SiMessenger className="contact__option-icon" />
            <h4>Messanger</h4>
            <h5>Tvk02jr</h5>
            <a href="https://m.me/tvk02jr" target="__blank">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <SiTelegram className="contact__option-icon" />
            <h4>Telegram</h4>
            <h5>Tomio Koshikawa</h5>
            <a href="https://t.me/bigboss0205" target="__blank">
              Send a message
            </a>
          </article>
        </div>
        {/* End of Contact Option */}

        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="subject"
            placeholder="Enter your subject here"
            required
          />

          <input
            type="text"
            name="name"
            placeholder="Enter your name here"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Enter your email here"
            required
          />

          <textarea
            name="message"
            rows="10"
            placeholder="Enter your message here"
            required
          />
          <div className="div__buttons">
            <button type="submit" className="btn btn-primary ">
              Send Message
            </button>
            <button type="reset" className="btn btn-primary form__button">
              Reset Form
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
